import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.dot-all.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.sticky.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.replace.js";
import axios from "axios";
import mapboxgl from "mapbox-gl";
import mapboxSdk from "@mapbox/mapbox-sdk/umd/mapbox-sdk";
import stringSimilarity from "string-similarity";
import { isMobile } from "@/js/mobile/mobile.js";
import { singleCadastreSelectionFiller, singleCadastreSelectionBorder, singleCadastreSelectionBorderGUID, manySelectionFillerGUID, manyGhostSelectionFiller, manySelectionFiller, VineyardsGUID } from "./layers";
export default {
  props: {
    guid: String,
    address: String,
    cadastreName: String,
    country: {
      type: String,
      default: ""
    },
    types: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  computed: {
    isRegion: function isRegion() {
      return this.types.includes("region");
    },
    isVineyard: function isVineyard() {
      return this.types.includes("vineyard");
    },
    isCadastre: function isCadastre() {
      return this.types.includes("cadastre");
    },
    isDisabledMap: function isDisabledMap() {
      return !this.isLoading && this.noTargetFound || this.isLoading && !this.noTargetFound;
    }
  },
  data: function data() {
    return {
      noTargetFound: false,
      isLoading: true,
      isPointerDisabled: true
    };
  },
  mounted: function mounted() {
    mapboxgl.accessToken = process.env.VUE_APP_MAPBOX_ACCESS_TOKEN;
    var map = new mapboxgl.Map({
      container: "container-map",
      style: this.guid ? "mapbox://styles/dfwav/cl3k93xcu002n15odokcupy1n?optimize=true" : "mapbox://styles/dfwav/ckk6kevd90nq717mi8667xtq6?optimize=true",
      center: [4.726338, 46.934328],
      zoom: 7,
      minZoom: 6.5,
      interactive: this.isMobile() ? false : true
    });
    var response = this.loadMap(map);
    if (!response) {
      var shouldUseAddress = this.isCadastre || this.isVineyard;
      var splitedUri = this.getUri(this.address.split(",").slice(1).join(","), shouldUseAddress, "postcode");
      this.loadMap(map, splitedUri);
    }
  },
  methods: {
    loadMap: function loadMap(map, uri) {
      var _this = this;
      map.on("load", function () {
        map.resize();
        var shouldUseAddress = _this.isCadastre || _this.isVineyard;
        if (!uri) {
          uri = _this.getUri(_this.address, shouldUseAddress);
        }
        axios.get(uri).then(function (_ref) {
          var data = _ref.data;
          var _data$features = _slicedToArray(data.features, 1),
            feature = _data$features[0];
          var place = feature === null || feature === void 0 ? void 0 : feature.context.find(function (x) {
            return x.id.includes("place");
          });
          if (_this.guid) {
            map.addSource("vineyards-guid", {
              type: "vector",
              url: "mapbox://dfwav.1ca86u23"
            });
          } else {
            map.addSource("vineyards", {
              type: "vector",
              url: "mapbox://dfwav.1omah9zi"
            });
          }
          if (!data.features.length && !_this.isRegion) {
            _this.handleViewForUnknownAddresses(map, _this.address);
          } else if (_this.guid) {
            _this.handleViewByGUID(map, feature.center);
          } else if (_this.isCadastre) {
            _this.handleCadastreView(map, place, feature.center);
          } else if (_this.isVineyard) {
            _this.handleVineyardView(map, place, feature.center);
          } else if (_this.isRegion) {
            map.once("moveend", function () {
              return _this.enablePointer();
            });
            map.jumpTo({
              zoom: 6.5,
              center: feature.center
            });
          } else {
            map.once("moveend", function () {
              return _this.enablePointer();
            });
            map.jumpTo({
              zoom: 8,
              center: feature.center
            });
          }
          _this.isLoading = false;
        });
      });
    },
    handleVineyardView: function handleVineyardView(map, place, center) {
      var _this2 = this;
      map.addLayer(manySelectionFiller(!this.isCadastre, place === null || place === void 0 ? void 0 : place.text), "vineyard-gc-filler");
      map.jumpTo({
        zoom: 8,
        center: center
      });
      map.once("idle", function () {
        map.once("moveend", function () {
          return _this2.enablePointer();
        });
        var features = _this2.getVineyardFeatures(map, "vineyards", "outnd");
        var places = features.map(function (x) {
          return x.properties.nomcom;
        }).filter(function (x) {
          return !!x;
        });
        if (places.length === 0) {
          _this2.handleViewForUnknownPlot(map, center);
          return;
        }
        var _stringSimilarity$fin = stringSimilarity.findBestMatch(place.text.toUpperCase(), places.map(function (x) {
            return x.toUpperCase();
          })),
          bestMatch = _stringSimilarity$fin.bestMatch;
        if (bestMatch.rating < 0.5) {
          _this2.handleViewForUnknownPlot(map, center);
          return;
        }
        var isEqual = function isEqual(x) {
          return x.properties.nomcom === bestMatch.target;
        };
        _this2.fitBounds(map, features.filter(isEqual));
        map.setMaxBounds(map.getBounds(), {
          padding: 50,
          bearing: 5
        });
      });
    },
    handleCadastreView: function handleCadastreView(map, place, center) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this3.isLoading = true;
              map.addLayer(
              // Todo: Wait and see buffer usages
              // this.cadastreName.toLowerCase() inside func
              manyGhostSelectionFiller(), "vineyard-gc-filler");
              map.jumpTo({
                zoom: 8,
                center: center
              });
              map.once("idle", function () {
                map.once("moveend", function () {
                  return _this3.enablePointer();
                });
                var features = _this3.getVineyardFeatures(map, "vineyards", "outnd");
                var appellations = features.map(function (x) {
                  return x.properties;
                }).map(function (x) {
                  return x.denom;
                }).filter(function (x) {
                  return !!x;
                });
                if (!appellations.length) {
                  _this3.handleVineyardView(map, place, center);
                  return;
                }
                var _stringSimilarity$fin2 = stringSimilarity.findBestMatch(_this3.smoothCadastreName(_this3.cadastreName, [{
                    target: "1er cru",
                    substitute: "premier cru"
                  }]), appellations),
                  bestMatch = _stringSimilarity$fin2.bestMatch;
                if (bestMatch.rating < 0.75) {
                  var alternative = stringSimilarity.findBestMatch(_this3.cadastreName.replace("Grand Cru", ""), appellations);
                  if (alternative.rating < 0.75) {
                    _this3.handleVineyardView(map, place, center);
                    return;
                  }
                }
                var isEqual = function isEqual(x) {
                  return x.properties.denom === bestMatch.target;
                };
                var plots = features.filter(isEqual);
                if (plots.length > 20) {
                  _this3.handleVineyardView(map, place, center);
                  return;
                }
                _this3.fitBounds(map, plots);
                map.addLayer(singleCadastreSelectionFiller(plots[0].properties.denom), "vineyard-gc-filler");
                map.addLayer(singleCadastreSelectionBorder(plots[0].properties.denom), "vineyard-pc-gc-clos-label");
                map.setFilter("vineyard-pc-gc-clos-label", ["==", plots[0].properties.denom, ["get", "denom"], ["collator", {
                  caseSensitive: false,
                  diacriticSensitive: false
                }]]);
              });
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    handleViewByGUID: function handleViewByGUID(map, center) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this4.isLoading = true;
              map.addLayer(VineyardsGUID(), "vineyard-plot");
              map.jumpTo({
                zoom: 8,
                center: center
              });
              map.once("idle", function () {
                map.once("moveend", function () {
                  return _this4.enablePointer();
                });
                var features = _this4.getVineyardFeatures(map, "vineyards-guid", "wineries-guid-3s50u6");
                var isEqual = function isEqual(x) {
                  return x.properties.guid === _this4.guid;
                };
                var plots = features.filter(isEqual);
                _this4.fitBounds(map, plots);
                map.addLayer(singleCadastreSelectionBorderGUID(plots[0].properties.guid), "vineyard-border");
                map.addLayer(manySelectionFillerGUID(true, plots[0].properties.guid), "vineyard-border");
              });
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    handleViewForUnknownPlot: function handleViewForUnknownPlot(map, center) {
      var marker = new mapboxgl.Marker({
        color: "#b47c3c"
      }).setLngLat(center).setPopup(new mapboxgl.Popup({
        offset: 25
      }).setHTML("<p>".concat(this.address, "<p>"))).addTo(map);
      map.setMaxBounds(map.getBounds(), {
        padding: 10,
        bearing: 5
      });
    },
    handleViewForUnknownAddresses: function handleViewForUnknownAddresses(map, address) {
      var mapboxClient = mapboxSdk({
        accessToken: mapboxgl.accessToken
      });
      mapboxClient.geocoding.forwardGeocode({
        query: address,
        autocomplete: false,
        limit: 1
      }).send().then(function (response) {
        var feature = response.body.features[0];
        var center = feature.center;
        map.jumpTo({
          zoom: 8,
          center: center
        });
        var marker = new mapboxgl.Marker({
          color: "#b47c3c"
        }).setLngLat(center).setPopup(new mapboxgl.Popup({
          offset: 25
        }).setHTML("<p>".concat(address, "<p>"))).addTo(map);
        map.setMaxBounds(map.getBounds(), {
          padding: 10,
          bearing: 5
        });
      });
    },
    getUri: function getUri(address, shouldUseAddress, addressType) {
      var uri = "".concat(process.env.VUE_APP_MAPBOX_GEOCODING_API_URL, "/mapbox.places/").concat(address, ".json?");
      if (!addressType) {
        uri += "types=".concat(shouldUseAddress ? "address" : this.types.join(","));
      } else {
        uri += "types=".concat(addressType);
      }
      uri += this.country ? "&country=".concat(this.country) : "";
      uri += "&access_token=".concat(mapboxgl.accessToken);
      return uri;
    },
    smoothCadastreName: function smoothCadastreName(cadastreName, options) {
      return options.reduce(function (acc, x) {
        var regEx = new RegExp(x.target, "i");
        return acc.replace(regEx, x.substitute);
      }, cadastreName);
    },
    fitBounds: function fitBounds(map, plots) {
      var firstCoord = this.seekFirstCoordinates(plots[0].geometry.coordinates);
      var bounds = plots.map(function (plot) {
        return plot.geometry.coordinates;
      }).reduce(this.seekDeepCoord, new mapboxgl.LngLatBounds(firstCoord, firstCoord));
      map.setMaxBounds(map.getBounds(), {
        padding: 40,
        bearing: 5
      });
      map.fitBounds(bounds, {
        padding: 10,
        bearing: 5,
        linear: this.isMobile() ? true : false
      });
    },
    getVineyardFeatures: function getVineyardFeatures(map, sourceFeatures, sourceLayer) {
      return map.querySourceFeatures(sourceFeatures, {
        sourceLayer: sourceLayer
      });
    },
    seekDeepCoord: function seekDeepCoord(acc, coords) {
      if (Array.isArray(coords[0])) return coords.reduce(this.seekDeepCoord, acc);
      return acc.extend(coords);
    },
    seekFirstCoordinates: function seekFirstCoordinates(coords) {
      if (Array.isArray(coords[0])) return this.seekFirstCoordinates(coords[0]);
      return coords;
    },
    displayNotFound: function displayNotFound() {
      this.noTargetFound = true;
    },
    enablePointer: function enablePointer() {
      this.isPointerDisabled = false;
    },
    isMobile: isMobile
  }
};